/**
 * Отображаемое имя менеджера для сортировки (Фамилия Имя, если есть части имени).
 */
export function getManagerDisplayName(manager) {
  if (!manager) return '';

  const surname = (manager.surname || '').trim();
  const name = (manager.name || '').trim();
  if (surname || name) {
    return `${surname} ${name}`.trim();
  }

  const displayName = (manager.displayName || manager.displaName || '').trim();
  if (displayName) return displayName;

  if (manager.firstName || manager.lastName) {
    return `${(manager.lastName || '').trim()} ${(manager.firstName || '').trim()}`.trim();
  }

  const label = (manager.label || '').trim();
  if (!label) return '';

  const parts = label.split(/\s+/);
  if (parts.length >= 2) {
    return `${parts.slice(1).join(' ')} ${parts[0]}`.trim();
  }
  return label;
}

/**
 * Сортировка списка менеджеров по алфавиту (русская локаль).
 */
export function sortManagersByLabel(list) {
  if (!Array.isArray(list)) return list;
  return [...list].sort((a, b) =>
    getManagerDisplayName(a).localeCompare(getManagerDisplayName(b), 'ru', { sensitivity: 'base' })
  );
}
